import React from "react";
const OfflineBanner = () => (React.createElement("div", { className: "offline-banner", role: "status" },
    React.createElement("span", { className: "offline-banner-text" }, "Offline \u2014 showing your saved data. Changes will not sync until you reconnect.")));
export default OfflineBanner;
